export const viewabilityEventSpecs = {
    'sign-in': {
        spec_id: '30ec9cc3-57f4-448b-b31b-3318e9cfaca0',
        spec_version: 'v1.2.0',
    },
    register: {
        spec_id: 'e0b4ea1a-0f5d-4f3f-8516-6abe682adffe',
        spec_version: 'v1.2.0',
    },
};
